import React, { FC } from 'react';
import cls from 'classnames';
import styles from './StepBreadcrumbs.module.css';
import { useState } from '../../../state/store';
import { StepType } from '../../../state/types';

interface StepBreadcrumbsProps {}

interface InternalStepProps {
  label: string;
  text: string;
  activeSteps: StepType[];
}

const StepBreadcrumbs: FC<StepBreadcrumbsProps> = () => {
  const { step, dispatch, breadcrumbsValidation } = useState('step', 'breadcrumbsValidation');
  if (step === StepType.Confirmation) {
    return null;
  }

  const Step = ({ label, text, activeSteps }: InternalStepProps) => {
    const isActiveForSteps = (steps: StepType[]) => steps.includes(step);
    const isActive = isActiveForSteps(activeSteps);
    const currentStep = activeSteps[0];
    const isValid = breadcrumbsValidation[currentStep];
    const onClick = isValid
      ? () => {
          dispatch('update', {
            step: currentStep,
          });
        }
      : undefined;
    return (
      <div className={cls('flex', styles.Step)}>
        <div
          onClick={onClick}
          className={cls(
            'flex justify-center rounded',
            'p-3 m-3',
            {
              'bg-dark text-white': isActive,
              'bg-light': !isActive,
            },
            {
              'cursor-pointer': !isActive && isValid,
              'hover:bg-dark hover:text-white': !isActive && isValid,
            }
          )}
          style={{
            minWidth: 250,
          }}
        >
          <div className="flex">
            <div className="flex flex-col">
              <div className={'text-center font-bold p-1'}>{label}</div>
              <div className={'text-center p-1'}>{text}</div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  return (
    <div className={styles.StepBreadcrumbs} data-testid="StepBreadcrumbs">
      <div className={`${styles.StepsBlock} w-full`}>
        <Step activeSteps={[StepType.NewDeviceCheck]} label={'Step 1'} text={'Insert your new device IMEI'} />
        <Step activeSteps={[StepType.OldDeviceModel]} label={'Step 2'} text={'Select your old device'} />
        <Step activeSteps={[StepType.OldDeviceStatus]} label={'Step 3'} text={'Trade in Device self-assessment'} />
        <Step activeSteps={[StepType.Details]} label={'Step 4'} text={'Insert your details'} />
      </div>
    </div>
  );
};

export default StepBreadcrumbs;
